package org.example.project.enginevertrieb

import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.json.*
import org.example.project.manager.LumaticaApiManager
import org.example.project.manager.LumaticaApiSettings
import org.example.project.utils.All
import org.w3c.fetch.RequestInit

internal object FlowProfileApi {
    private val json = Json { ignoreUnknownKeys = true; encodeDefaults = true }
    private suspend fun request(action: String, body: String? = null): String {
        val response = window.fetch("${LumaticaApiSettings.getBaseUrl()}/api/vertriebsindex/$action", RequestInit(
            method = if (body == null) "GET" else "POST", headers = LumaticaApiManager.auditHeaders("application/json"), body = body)).await()
        val raw = response.text().await()
        if (!response.ok) error(runCatching { json.parseToJsonElement(raw).jsonObject["message"]?.jsonPrimitive?.contentOrNull }.getOrNull() ?: "Flow-Profile: HTTP ${response.status}")
        return raw
    }
    suspend fun load(): List<All> = json.decodeFromString(ListSerializer(All.serializer()), request("flow-profiles"))
    suspend fun save(value: All): All {
        val saved = json.decodeFromString(All.serializer(), request("flow-profile-save", json.encodeToString(All.serializer(), value)))
        check(saved.id.isNotBlank() && (value.id.isBlank() || saved.id == value.id) && saved.vertriebCallName == value.vertriebCallName.trim() &&
            saved.vertriebScriptBereich == value.vertriebScriptBereich && saved.vertriebCallFlow.size == value.vertriebCallFlow.size && saved.vertriebCallCheckboxen.size == value.vertriebCallCheckboxen.size) { "Speichern wurde vom Server nicht bestätigt. Bitte den aktualisierten Node starten." }
        return saved
    }
    suspend fun delete(id: String): List<All> {
        require(id.isNotBlank())
        val result = json.decodeFromString(ListSerializer(All.serializer()), request("flow-profile-delete", buildJsonObject { put("id", id) }.toString()))
        check(result.none { it.id == id }) { "Löschen wurde vom Server nicht bestätigt." }
        return result
    }
}


internal fun flowIdForLead(lead: All?, types: List<VertriebsindexApi.LeadTypEintrag>, method: String): String {
    if (lead == null) return ""
    return types.firstOrNull { lead.leadTypId.isNotBlank() && it.id == lead.leadTypId || lead.leadTyp.isNotBlank() && it.leadTyp == lead.leadTyp }
        ?.flowProfileIds?.get(method).orEmpty()
}
